/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import React from 'react';
import AlertLib from 'react-s-alert';
import history from './history';

const AlertHandler = props => {
    React.useEffect(() => {
        const unregisterCallback = history.listen(() => {
            // Remove Dialog if page change
            if (AlertHandler.removeId) {
                AlertLib.close(AlertHandler.removeId);
                AlertHandler.removeId = undefined;
            }
        });
        return () => {
            unregisterCallback();
        };
    }, []);

    /**
     * Global config for alert
     */
    return <AlertLib effect={'stackslide'} position={'top'} />;
};

/**
 *
 * @param {string} msg
 * @param {object} [options]
 * @param {string} [options.position]
 * @param {boolean} [options.html]
 * @param {(string|number)} [options.timeout] - Deprecated: timeout was considered from type of message
 */
AlertHandler.info = (msg, options, timeout = 6000) => {
    AlertLib.closeAll();
    AlertLib.info(msg, {
        ...options,
        timeout,
    });
};

/**
 *
 * @param {string} msg
 * @param {object} [options]
 * @param {string} [options.position]
 * @param {boolean} [options.html]
 * @param {(string|number)} [options.timeout] - Deprecated: timeout was considered from type of message
 */
AlertHandler.error = (msg, options) => {
    AlertLib.closeAll();
    AlertHandler.removeId = AlertLib.error(msg, {
        ...options,
        timeout: 'none',
    });
};

/**
 *
 * @param {string} msg
 * @param {object} [options]
 * @param {string} [options.position]
 * @param {boolean} [options.html]
 * @param {(string|number)} [options.timeout] - Deprecated: timeout was considered from type of message
 */
AlertHandler.warning = (msg, options) => {
    AlertLib.closeAll();
    AlertLib.warning(msg, {
        ...options,
        timeout: 6000,
    });
};

/**
 *
 * @param {string} msg
 * @param {object} [options]
 * @param {string} [options.position]
 * @param {boolean} [options.html]
 * @param {(string|number)} [options.timeout] - Deprecated: timeout was considered from type of message
 */
AlertHandler.success = (msg, options) => {
    AlertLib.closeAll();
    AlertLib.success(msg, {
        ...options,
        timeout: 2500,
    });
};

/**
 * Close dialog
 */
AlertHandler.close = () => {
    AlertLib.closeAll();
};

AlertHandler.removeId = undefined;

export default AlertHandler;
